import { render, staticRenderFns } from "./WordCloudFilter.vue?vue&type=template&id=bc0bf102&scoped=true&"
import script from "./WordCloudFilter.vue?vue&type=script&lang=js&"
export * from "./WordCloudFilter.vue?vue&type=script&lang=js&"
import style0 from "./WordCloudFilter.vue?vue&type=style&index=0&id=bc0bf102&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc0bf102",
  null
  
)

export default component.exports